import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gallery-container" }
const _hoisted_2 = { class: "gallery-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "card gallery-card"
}
const _hoisted_5 = {
  key: 0,
  class: "assets-wrapper"
}
const _hoisted_6 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString($props.title), 1),
        _createElementVNode("button", {
          class: "button default primary add-btn-primary",
          onClick: $setup.openModal
        }, "Add " + _toDisplayString($props.title), 1)
      ]),
      ($setup.assets?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  ($setup.props.galleryType === 'inclusion')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.assets, (inclusion) => {
                        return (_openBlock(), _createBlock($setup["InclusionCard"], {
                          key: inclusion._id,
                          inclusion: inclusion,
                          onDelete: (inclusion) => $setup.confirmDelete(inclusion),
                          onUpdateInclusion: (dto) => $setup.updateInclusion(inclusion, dto),
                          onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadInclusionGallery = true))
                        }, null, 8, ["inclusion", "onDelete", "onUpdateInclusion"]))
                      }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.assets, (asset) => {
                        return (_openBlock(), _createBlock($setup["AssetItemCard"], {
                          builderId: $setup.props.builderId,
                          key: asset._id,
                          asset: asset,
                          formType: $setup.props.galleryType,
                          title: $setup.props.title,
                          uploadImage: $setup.props.uploadImage,
                          onDelete: (asset) => $setup.confirmDelete(asset),
                          onUpdateFacade: (dto) => $setup.updateFacade(asset, dto),
                          onUpdateInternalColorScheme: (dto) => $setup.updateInternalColorScheme(asset, dto),
                          onUpdateOptionalUpgrade: (dto) => $setup.updateOptionalUpgrade(asset, dto),
                          onConfirm: _cache[1] || (_cache[1] = ($event: any) => ($setup.reloadAssetGallery = true))
                        }, null, 8, ["builderId", "asset", "formType", "title", "uploadImage", "onDelete", "onUpdateFacade", "onUpdateInternalColorScheme", "onUpdateOptionalUpgrade"]))
                      }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode($setup["AddAndUpdateAssetInGalleryModal"], {
      isOpen: $setup.assetGalleryModalOpen,
      builderId: $setup.props.builderId,
      formType: $setup.props.galleryType,
      title: $setup.props.title,
      uploadImage: $setup.props.uploadImage,
      mode: "create",
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => ($setup.reloadAssetGallery = true)),
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.assetGalleryModalOpen = false)),
      onCreateFacade: $setup.createFacade,
      onCreateInternalColorScheme: $setup.createInternalColorScheme,
      onCreateOptionalUpgrade: $setup.createOptionalUpgrade
    }, null, 8, ["isOpen", "builderId", "formType", "title", "uploadImage"]),
    _createVNode($setup["AddAndUpdateInclusionModal"], {
      isOpen: $setup.inclusionModalOpen,
      builderId: $setup.props.builderId,
      title: $setup.props.title,
      mode: "create",
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reloadInclusionGallery = true)),
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.inclusionModalOpen = false)),
      onCreateInclusion: $setup.createInclusion
    }, null, 8, ["isOpen", "builderId", "title"]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.isConfirmDeleteModalOpen,
      deleteItem: `${$setup.props.title} '${$setup.props.galleryType === 'inclusion' ? $setup.assetToDelete?.type : $setup.assetToDelete?.name}'`,
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => ($setup.deleteAsset($setup.assetToDelete))),
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isConfirmDeleteModalOpen = false))
    }, null, 8, ["isOpen", "deleteItem"])
  ], 64))
}